module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Mail-attachment-18f025d79918ba155f4b009d4648e7b0.svg";